const TOLSTOY_PLAY_APP_URL = process.env.NEXT_PUBLIC_APP_URL;
const SHOPIFY_INSTALL_URL = process.env.NEXT_PUBLIC_INSTALL_SHOPIFY_URL;

export enum Routes {
  OnsiteCreate = '/onsite/create',
  ShopApp = '/shop-app',
  EmailCreate = '/offsite/create',
  VideoLibrary = '/video_library',
  InstagramLibrary = '/video_library/instagramGraph',
  GoogleDriveLibrary = '/video_library/googleDrive',
  DropboxLibrary = '/video_library/dropbox',
  TiktokLibrary = '/video_library/tiktok',
}

class TolstoyServiceClass {
  Routes = Routes;

  getFullUrl = (route?: Routes) => {
    return `${TOLSTOY_PLAY_APP_URL}${route ?? ''}`;
  };

  installApp = (appKey: string, appUrl: string) => {
    window.open(`${SHOPIFY_INSTALL_URL}?shop=${appUrl}&app_key=${appKey}`, '_blank');
  };

  redirectToTolstoy = (route?: Routes, params?: URLSearchParams) => {
    window.open(`${TOLSTOY_PLAY_APP_URL}${route}?${params?.toString()}`, '_blank');
  };
}

export const TolstoyService = new TolstoyServiceClass();
